import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/account/password/reset')({
  component: () => <Outlet />,
})
